<mat-checkbox [disableRipple]="true" [(ngModel)]="value" [disabled]="disabled" [aria-describedby]="userAriaDescribedBy">
    <ng-content></ng-content>
</mat-checkbox>
